module.exports = __webpack_public_path__ + "img/partner-coupon-banner.aeebbfcf.png";